import React from 'react';
import {connect} from 'react-redux';

import FullWidthPage from '../Presentation/FullWidthPage';
import SectionTitle from '../Presentation/SectionTitle';
import Talisman from '../Presentation/Talisman';

class Cookies extends React.Component {

    render() {
        return <FullWidthPage title="Бисквитки">
            <div className="col-md-12">
                <SectionTitle>Какво са „бисквитки“</SectionTitle>

                <p>„Бисквитките“ са малки текстови файлове, които се запазват на Вашия компютър или мобилно устройство. Функцията на „бисквитките“ е да Ви разграничат от останалите потребители на същия уеб сайт или да запазят определена информация, свързана с Вашите предпочитания. Използват се от повечето сайтове, за да улеснят Вашето сърфиране.</p>

                <p>Всяка „бисквитка“ е уникална за Вашия браузър и съдържа анонимна информация. Съдържанието включва наименованието на домейна, от която идва, „продължителността на живота“ й и стойност, обикновено под формата на произволно генериран номер.</p>

                <p>Какви видове използваме и за какво са предназначени:</p>

                <h4>Сигурност и идентифициране</h4>

                <p>Целта на „бисквитките“, предназначени за сигурност на връзката, е:</p>

                <ul>
                    <li>Да разпознаят потребителя в рамките на конкретната сесия</li>
                    <li>Да контролират сигурността</li>
                    <li>Да гарантират, че информацията, която потребителя въвежда, се вижда единствено от него</li>
                </ul>
                    <p>Бисквитките за сигурност и идентифициране се изтриват автоматично след прекратяване на сесията на Вашия браузър и ли се пазят за ограничено време с цел осигуряване на безпрепятствена работа със сайта. Важно е да се отбележи, че тези, както и останалите видове бисквитки на сайта, не съхраняват въведените лични данни.</p>

                <h4>Ефективност и функционалност</h4>

                <p>„Бисквитките“ за производителност целят събиране на статистическа информация и предоставяне на съдържание спрямо индивидуалните предпочитания на потребителите. Чрез тях ние анонимно измерваме броя посещения, разгледаните страници, активността на посетителите, както и повторните посещения на сайта. Тези „бисквитки“ ни помагат да анализираме трафика, което ни позволява да подобряваме уебсайта, както и цялостното потребителско изживяване.</p>

                <h4>Управляване и изтриване на „бисквитки“</h4>
                <p>Моля, имайте предвид, че голяма част от „бисквитките“, които използваме, ще подобрят сърфирането Ви в нашия уебсайт, а останалата част са важни за гарантиране сигурността на достъпа.</p>

                <p>В зависимост от използваният браузър Вие имате възможност:</p>

                <ul>
                    <li>Да разрешите или откажете съхранението на бисквитки от всички източници</li>
                    <li>Да настроите известие, което при всяка нова "бисквитка" ще иска разрешение за приемане или отказване</li>
                    <li>Повечето браузъри са настроени да приемат „бисквитки“ по подразбиране. Въпреки това, ако не желаете "бисквитките" да бъдат съхранявани на Вашия компютър, Вие имате възможност да ги ограничите чрез промяна на настройките на ползвания браузър.</li>
                </ul>

                <Talisman />
            </div>
        </FullWidthPage>
    }
}

const mapStateToProps = (state) => {
    return {}
};

const mapDispatchToProps = (dispatch) => {
    return {dispatch}
};

export default connect(mapStateToProps, mapDispatchToProps, null, {withRef: true})(Cookies);




// WEBPACK FOOTER //
// ./src/components/Pages/Cookies.js